import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter, withEnabledBlockingInitialNavigation } from "@angular/router";
import { providers } from "@app/providers";
import { routes } from "@app/routes";
import { AppComponent } from "@core/containers/app.component";
import { environment } from "@environments/environment";

// SDX
import { defineCustomElements } from "@swisscom/sdx";

async function main() {
  // Enable production mode if the environment is set to production
  if (environment.production) {
    enableProdMode();
  }

  // Bootstrap the Angular application
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      provideRouter(routes, withEnabledBlockingInitialNavigation()),
      ...providers,
      ...environment.providers,
      ...environment.imports.map((imp) => importProvidersFrom(imp))
    ]
  }).catch((error) => console.error(error));

  // Define custom elements for SDX
  defineCustomElements();
}

// Start the main function to bootstrap the application
main().catch((error) => {
  console.error("Error during application initialization:", error);
});
